import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const LogoutIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 13.539 12.714"
      height={getDefaultHeight(svgProps, 12.714)}
      {...svgProps}
    >
      <g
        fill="none"
        stroke={color ?? "currentColor"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
      >
        <path d="M4.303 6.359h8.636" />
        <path d="M10.883 8.415l2.056-2.056-2.056-2.056" />
        <path d="M8.827 8.825v2.467a.788.788 0 01-.748.822H1.353a.788.788 0 01-.747-.822v-9.87A.787.787 0 011.353.6h6.726a.788.788 0 01.748.822V3.89" />
      </g>
    </SVG>
  );
};
